import { render, staticRenderFns } from "./NoshiPage.vue?vue&type=template&id=6ea77834&scoped=true&lang=pug&"
import script from "./NoshiPage.vue?vue&type=script&lang=ts&"
export * from "./NoshiPage.vue?vue&type=script&lang=ts&"
import style0 from "./NoshiPage.vue?vue&type=style&index=0&id=6ea77834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea77834",
  null
  
)

export default component.exports